"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Tooltip = _interopRequireDefault(require("@eig-builder/core-ui/Tooltip"));

var _styles = require("@eig-builder/core-ui/styles");

var _dataGridContext = _interopRequireDefault(require("../../data-grid-context"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    active: {
      backgroundColor: "rgba(0,0,0,0.08)"
    },
    rearrangeBtn: {
      display: "inline-block",
      "& .icon": {
        color: "$primitive-text-secondary !important",
        verticalAlign: "baseline"
      },
      "&:hover": {
        "& .icon": {
          color: "$primitive-text-primary !important"
        },
        backgroundColor: "$navbar-active-background-color",
        cursor: "pointer"
      }
    }
  };
});

var RearrangeComponent = function RearrangeComponent(props) {
  var tooltip = props.tooltip,
      tag = props.tag,
      hasRearrange = props.hasRearrange,
      setRearrange = props.setRearrange;

  var _useContext = (0, _react.useContext)(_dataGridContext["default"]),
      selectedNodes = _useContext.selectedNodes,
      setSelectedNodes = _useContext.setSelectedNodes,
      gridApi = _useContext.gridApi;

  (0, _react.useEffect)(function () {
    if (hasRearrange && !(0, _isEmpty["default"])(selectedNodes)) {
      setSelectedNodes([]);
      gridApi && gridApi.deselectAll();
    }
  }, [hasRearrange]);
  var classes = useStyles();
  var dataElementTag = 'rearrange-button-' + tag;
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip.text,
    placement: "top",
    className: "".concat(classes.rearrangeBtn, " ").concat(hasRearrange && !selectedNodes.length ? classes.active : '')
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: function onClick() {
      return setRearrange();
    },
    tag: dataElementTag,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: dataElementTag,
    dataElementId: dataElementTag
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "icon",
    icon: "format_line_spacing"
  }))));
};

RearrangeComponent.propTypes = {
  tag: _propTypes["default"].string,
  tooltip: _propTypes["default"].object,
  hasRearrange: _propTypes["default"].bool,
  setRearrange: _propTypes["default"].func
};
var _default = RearrangeComponent;
exports["default"] = _default;